var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('div',{staticClass:"dispatch-board"},[_c('activities',{attrs:{"current-job-id":_vm.id,"readonly":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }